import { format } from "date-fns";
import { atom } from "jotai";

export const selectedFacilityId_atom = atom<string | null>(null);
export const selectedFacilityName_atom = atom<string | null>(null);
export const selectedPartySize_atom = atom<number>(4);
export const selectedDate_atom = atom<string>(format(new Date(), "yyyy-MM-dd"));
export const selectedSeatingShift_atom = atom<{
  name: string;
  startTime: string;
  endTime: string;
} | null>(null);
